import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import OurStoryPageStyle from "./our-story-page.module.scss"

const SteveMobileImg = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "steve-mobile.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img className={OurStoryPageStyle.steveMobileImg} fluid={data.placeholderImage.childImageSharp.fluid} />
}

export default SteveMobileImg
